module.exports = __webpack_public_path__ + "static/img/back_icon_1.166b244.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back_icon_1.png
// module id = YdjH
// module chunks = 1